import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "mx-4 text-xs text-left grid grid-cols-8 border-b dark:bg-dark-800 dark:text-dark-text dark:border-dark-300 bg-white border-gray-300 text-gray-600",
  style: {"padding-left":"44px"}
}
const _hoisted_2 = { class: "py-2 px-2 text-center col-span-2" }
const _hoisted_3 = { class: "py-2 px-2 text-center" }
const _hoisted_4 = { class: "py-2 px-2 text-center col-span-2" }
const _hoisted_5 = { class: "py-2 px-2 text-center col-span-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('message.judgeId')), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('message.status')), 1),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('message.language')), 1),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('message.submitDate')), 1)
  ]))
}